import React, { useEffect, useState } from 'react';
import { getScheduleSurveyRequest, IScheduleReminder, IScheduleSurvey } from '../services/surveys';

const useScheduleContent = (
  surveyId: string,
  setIsTransitionBlocked: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [schedule, setSchedule] = useState<IScheduleSurvey>({
    start_date: null,
    end_date: '',
    contact_name: '',
    contact_email: '',
    include_sms_invitation: false,
    reminders: [],
  });

  const getSchedule = async () => {
    const response = await getScheduleSurveyRequest(surveyId);
    setSchedule(response);
  };

  useEffect(() => {
    getSchedule();
  }, [surveyId]);

  const updateSchedule = (updates: Partial<IScheduleSurvey>) => {
    setSchedule(prev => ({
      ...prev,
      ...updates,
      reminders: updates.reminders ?? prev.reminders,
    }));
    setIsTransitionBlocked(true);
  };

  const updateAndSortReminders = (updates: Partial<IScheduleSurvey>) => {
    const updatedReminders: IScheduleReminder[] = updates.reminders ?? schedule.reminders;

    const sortedReminders = [...updatedReminders]
      .map((reminder, originalIndex) => ({ reminder, originalIndex }))
      .sort((a, b) => {
        if (!a.reminder.execute_at || !b.reminder.execute_at) return 0;
        return (
          new Date(a.reminder.execute_at).getTime() - new Date(b.reminder.execute_at).getTime()
        );
      })
      .map(item => item.reminder);

    setSchedule(prev => ({
      ...prev,
      ...updates,
      reminders: sortedReminders,
    }));

    setIsTransitionBlocked(true);
  };

  return { schedule, updateSchedule, updateAndSortReminders };
};

export default useScheduleContent;
